module.exports = __webpack_public_path__ + "static/scale-model-of-ashland---the-henry-clay-estate-in-lexington-kentucky-7070fd63b5d54bc775accf399d28250c.png";